;(function () {
  'use strict'

  angular
    .module('contrast.attacks')
    .factory('IPBlacklistModalService', [
      '$uibModal',
      '$translate',
      IPBlacklistModalService
    ])

  function IPBlacklistModalService($uibModal, $translate) {
    var _modalSize = 'lg'

    // API
    var service = {
      openCreate: openCreate
    }

    return service

    // Function Definitions
    function openCreate(attack) {
      var openParams = {
        templateUrl: 'views/rules/ip/modal_create.html',
        controller: 'ModalBlacklistIPCtrl',
        size: _modalSize,
        windowClass: 'attack-blacklist-modal',
        resolve: {
          attack: function () {
            return attack
          },
          title: function () {
            return $translate.instant('title_addIpToDenylist')
          }
        }
      }

      return $uibModal.open(openParams).result
    }
  }
})()
